"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _postBoxActions = require("./postBoxActions");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    loading: true
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _postBoxActions.PostBoxActionTypes.LOAD_DOCUMENTS:
      return _objectSpread(_objectSpread({}, state), {}, {
        documents: action.documents,
        loading: false
      });
    case _postBoxActions.PostBoxActionTypes.LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true
      });
    case _postBoxActions.PostBoxActionTypes.HAS_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        hasError: true,
        errorStatus: action.errorStatus,
        errorCode: action.errorCode
      });
    default:
      return state;
  }
}
var _default = exports.default = reducer;